const dashboard = {
  homeToDashboard: (to, from, next) => {
    if (to.path == "/") next({ path: "/dashboard" });
    else next();
  }
};

export default dashboard;
